<!-- Gamedata Settings -->
<div class="settings-section">
  <h3 class="section-title">Gamedata</h3>
  <div class="gamedata-settings-grid">
    <!-- Production Settings Column -->
    <div class="settings-column">
      <h4 class="column-header">Production</h4>
      <div class="setting-item">
        <label>Auto Prod Push</label>
        <p-inputSwitch [(ngModel)]="autoProdPushEnabled" (onChange)="handleProdPushChange($event, true)"></p-inputSwitch>
      </div>
      <div class="setting-item">
        <label>Manual Prod Push</label>
        <p-inputSwitch [(ngModel)]="manualProdPushButtonEnabled"
          (onChange)="handleProdPushChange($event, false)"></p-inputSwitch>
      </div>
    </div>

    <!-- Development Settings Column -->
    <div class="settings-column">
      <h4 class="column-header">Development</h4>
      <div class="setting-item">
        <label>Manual Dev Push</label>
        <p-inputSwitch [(ngModel)]="manualDevGamedataPushEnabled"
          (onChange)="handleManualDevGamedataPushEnabledChange($event)"></p-inputSwitch>
      </div>
      <div class="setting-item">
        <label>Auto Dev + QA Push</label>
        <p-inputSwitch [(ngModel)]="autoDevQAPushEnabled"
          (onChange)="handleAutoDevQAPushEnabledChange($event)"></p-inputSwitch>
      </div>
    </div>

    <!-- QA Settings Column -->
    <div class="settings-column">
      <h4 class="column-header">QA/Test</h4>
      <div class="setting-item">
        <label>Manual QA Push</label>
        <p-inputSwitch [(ngModel)]="manualQAGamedataPushEnabled"
          (onChange)="handleManualQAGamedataPushEnabledChange($event)"></p-inputSwitch>
      </div>
      <div class="setting-item">
        <label>Manual Dev + QA Push</label>
        <p-inputSwitch [(ngModel)]="manualDevQAGamedataPushEnabled"
          (onChange)="handleManualDevQAGamedataPushEnabledChange($event)"></p-inputSwitch>
      </div>
    </div>

    <!-- System Administration Column -->
    <div class="settings-column">
      <h4 class="column-header">System Administration</h4>
      <div class="setting-item-full">
        <button pButton pRipple 
          icon="pi pi-refresh" 
          class="p-button-danger" 
          (click)="resetGamedataSystem()"
          label="Reset Gamedata System"
          [disabled]="isResetting"
          style="width: 100%;">
        </button>
        <p *ngIf="isResetting" class="p-mt-2" style="text-align: center;">
          <i class="pi pi-spin pi-spinner"></i> Resetting system...
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Database Settings -->
<div class="settings-section" *ngIf="!isProd">
  <h3 class="section-title">Database</h3>
  <div class="database-actions">
    <div class="database-action-buttons">
      <button pButton pRipple
        [icon]="isSyncingDB ? 'pi pi-spin pi-spinner' : 'pi pi-database'"
        class="p-button-success"
        (click)="syncDB()"
        [disabled]="isSyncingDB"
        [label]="isSyncingDB ? 'Syncing...' : 'Sync Database'">
      </button>
      <button pButton pRipple
        *ngIf="env === 'dev' || env === 'test'"
        [icon]="isSyncingLocalizationDB ? 'pi pi-spin pi-spinner' : 'pi pi-globe'"
        class="p-button-success"
        (click)="syncLocalizationDB()"
        [disabled]="isSyncingLocalizationDB"
        [label]="isSyncingLocalizationDB ? 'Syncing Localization...' : 'Sync Localization Database'">
      </button>
    </div>
    <div *ngIf="syncStatus" class="sync-status p-mt-2" style="font-size: 0.85rem; color: #666;">
      <span *ngIf="syncStatus.inProgress">
        <i class="pi pi-spin pi-spinner"></i>
        MongoDB sync in progress — started by <strong>{{ syncStatus.startedBy }}</strong>
      </span>
      <span *ngIf="!syncStatus.inProgress && syncStatus.lastStatus === 'success'" style="color: #2e7d32;">
        <i class="pi pi-check-circle"></i> {{ syncStatus.lastMessage }}
      </span>
      <span *ngIf="!syncStatus.inProgress && syncStatus.lastStatus === 'failed'" style="color: #c62828;">
        <i class="pi pi-times-circle"></i> {{ syncStatus.lastMessage }}
      </span>
    </div>
    <div *ngIf="localizationSyncStatus" class="sync-status p-mt-2" style="font-size: 0.85rem; color: #666;">
      <span *ngIf="localizationSyncStatus.inProgress">
        <i class="pi pi-spin pi-spinner"></i>
        Localization MySQL sync in progress — started by <strong>{{ localizationSyncStatus.startedBy }}</strong>
      </span>
      <span *ngIf="!localizationSyncStatus.inProgress && localizationSyncStatus.lastStatus === 'success'" style="color: #2e7d32;">
        <i class="pi pi-check-circle"></i> {{ localizationSyncStatus.lastMessage }}
      </span>
      <span *ngIf="!localizationSyncStatus.inProgress && localizationSyncStatus.lastStatus === 'failed'" style="color: #c62828;">
        <i class="pi pi-times-circle"></i> {{ localizationSyncStatus.lastMessage }}
      </span>
    </div>
  </div>
</div>

<!-- Default Records -->
<div class="settings-section">
  <h3 class="section-title">Default Records</h3>
  <div class="default-records-grid">
    <div class="default-record-item">
      <label>Default Perks</label>
      <p-multiSelect 
        [options]="perks" 
        [(ngModel)]="selectedDefaultPerks" 
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [style]="{'width': '100%', 'max-width': '500px'}"
        placeholder="Select Default Perks"
        (onChange)="onDefaultPerksChange($event)"
        display="chip">
        <ng-template pTemplate="item" let-perk>
          {{perk.name}} ({{perk.id}})
        </ng-template>
        <ng-template pTemplate="selectedItem" let-perk>
          {{perk.name}} ({{perk.id}})
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
</div>
  
<p-confirmDialog></p-confirmDialog>